import { render, staticRenderFns } from "./ManagePositionRequestStatus.vue?vue&type=template&id=3fb9383c"
import script from "./ManagePositionRequestStatus.vue?vue&type=script&lang=js"
export * from "./ManagePositionRequestStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports